import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { EnvironmentHelper } from "./helpers";

EnvironmentHelper.init();

Sentry.init({
  dsn: "https://d1ebda69b5a69b968e222e084a39eccf@o4510468642570240.ingest.us.sentry.io/4510468644208640",
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
